import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Screens from '@/pages/Screens';
import ScreenGroups from '@/pages/ScreenGroups';
import Content from '@/pages/Content';
import Schedules from '@/pages/Schedules';
import Users from '@/pages/Users';
import Display from '@/pages/Display';
import GroupDisplay from '@/pages/GroupDisplay';
import { AuthProvider, useAuth } from '@/context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950">
        <div className="text-white text-xl">Ładowanie...</div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/display/:screenId" element={<Display />} />
          <Route path="/display/group/:groupId" element={<GroupDisplay />} />
          
          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          
          <Route path="/screens" element={
            <PrivateRoute>
              <Screens />
            </PrivateRoute>
          } />
          
          <Route path="/screen-groups" element={
            <PrivateRoute>
              <ScreenGroups />
            </PrivateRoute>
          } />
          
          <Route path="/content" element={
            <PrivateRoute>
              <Content />
            </PrivateRoute>
          } />
          
          <Route path="/schedules" element={
            <PrivateRoute>
              <Schedules />
            </PrivateRoute>
          } />
          
          <Route path="/users" element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;